<template>
  <Preloader/>
  <MenuNav @topScrollTo="scrollToTop"/>
  
  <router-view/>
  <a class="to-top" href="#home">
		<i class="fa fa-angle-double-up" aria-hidden="true"></i>
	</a>
  <FooterV/>
</template>
<script>
import MenuNav from './components/MenuNav.vue';
import FooterV from './components/FooterV.vue';
import Preloader from './components/Preloader.vue';
import { ref } from 'vue';
export default {
  components:{
    MenuNav,
    FooterV,
    Preloader,
  },
  props:{},
  data(){
    return{
      top: ref(false),
    }
  },
  mounted(){
    if(1<0){
      this.$router.push({ path: '/mantenimiento', replace: true })
    }
  },
  methods:{
    scrollToTop(valor) {
      if(valor != false){
        console.log("Se ve "+ valor);
        this.top = valor;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        valor = this.top;
      }
       // Desplázate suavemente hasta la parte superior
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #FECA31;
}

</style>
